<div class="flex flex-col flex-1 gap-2">
  <dx-form
    [formData]="formData"
    (onFieldDataChanged)="onFieldDataChanged()"
    class="flex-1"
    [colCount]="2"
    [readOnly]="readonly"
  >
    <dxi-item
      dataField="user"
      editorType="dxSelectBox"
      [editorOptions]="{
        displayExpr: 'display',
        valueExpr: 'value',
        dataSource: userDataSource
      }"
      [label]="{
        text: 'Utente' | transloco,
        location: 'top',
        visible: true,
        showColon: false
      }"
    ></dxi-item>
    <dxi-item
      dataField="align"
      editorType="dxSelectBox"
      [editorOptions]="{
        valueExpr: 'value',
        displayExpr: 'label',
        dataSource: [
          { value: 'left', label: 'Sinistra' | transloco },
          { value: 'center', label: 'Centro' | transloco },
          { value: 'right', label: 'Destra' | transloco }
        ]
      }"
      [label]="{
        text: 'Allinea' | transloco,
        location: 'top',
        visible: true,
        showColon: false
      }"
    ></dxi-item>
  </dx-form>
</div>
